import React, { useEffect, useState } from 'react'
import './AdminTeamList.css'
import { NavLink } from 'react-router-dom'
import Modal from '../../shared/components/UIElements/Modal'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import AdminNavigation from './AdminNavigation'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminTryoutResultsList = () => {
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [loadedTryoutResults, setLoadedTryoutResults] = useState()
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [deletedTryoutResultsId, setDeletedTryoutResultsId] = useState('')
	const [tryoutResultsDeleted, setTryoutResultsDeleted] = useState()

	//First, lets tap into the following route on the backend to get all news:
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setTryoutResultsDeleted(false)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + `/admin/tryoutresults`
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTryoutResults(responseData.allTryoutResults)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [tryoutResultsDeleted])

	const errorHandler = () => {
		setError(null)
	}

	//******************************************************** */
	//
	//     Delete warning
	//
	//******************************************************** */
	const showDeleteWarningHandler = (e) => {
		const value = e.target.id
		setDeletedTryoutResultsId(loadedTryoutResults[value]._id)
		setShowConfirmModal(true)
	}

	const cancelDeleteHandler = () => {
		setShowConfirmModal(false)
	}

	const confirmDeleteHandler = async () => {
		setShowConfirmModal(false)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${deletedTryoutResultsId}/removeTryoutResults`,
				'DELETE'
			)
		} catch (err) {}
		setTryoutResultsDeleted(true)
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmModal}
				onCancel={cancelDeleteHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to delete this Tryout Results instance?
						</p>
						<br></br>
						<button
							className='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							style={{ color: 'red' }}
							danger
							onClick={confirmDeleteHandler}
						>
							DELETE
						</button>
					</React.Fragment>
				}
			></Modal>
			{!isLoading && loadedTryoutResults && (
				<div className='TryoutResults'>
					<AdminNavigation />
					<h1>Tryout Results</h1>
					<table id='tryoutresults'>
						<thead>
							<tr>
								<th>Year</th>
								<th>Division</th>
								<th>Team Name</th>
								<th>Head Coach</th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{loadedTryoutResults.map((results, key) => {
								return (
									<tr key={key}>
										<td>{results.year}</td>
										<td>{results.division}</td>
										<td>{results.teamName}</td>
										<td>{results.headCoach}</td>
										<td>
											<NavLink
												className='navlinks'
												to={`/admin/updateTryoutResults/${results._id}`}
												exact
											>
												Edit
											</NavLink>
										</td>
										<td>
											<button
												className='buttonButton'
												style={{ color: 'red' }}
												id={key}
												onClick={(e) => showDeleteWarningHandler(e)}
											>
												DELETE
											</button>
										</td>
									</tr>
								)
							})}
						</tbody>
						<div style={{ width: '150%', marginTop: '1rem' }}>
							<AdminButton
								to={`/admin/tryout/results`}
								exact
								style={{
									color: 'white',
									textDecoration: 'none',
								}}
							>
								Add new Team Tryout Results
							</AdminButton>
						</div>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminTryoutResultsList
